export default {
    firstName: (state) => state.firstName,
    lastName: (state) => state.lastName,
    email: (state) => state.email,
    phone: (state) => state.phone,
    address1: (state) => state.address1,
    address2: (state) => state.address2,
    city: (state) => state.city,
    state: (state) => state.state,
    zip: (state) => state.zip,
    country: (state) => state.country,
    PONumber: (state) => state.PONumber,
    billing: state => state,
}
